<template>
  <div v-if="id === 1" style="background-color: #f5f5f5">
    <b-container>
      <b-row>
        <b-col align="center">
          <h5>Swift 코딩 클럽</h5>
          <p>Everyone Can Code</p>
          <p>
            스위프트 코딩 클럽을 통해 앱을 디자인하고 개발할 수 있습니다.
            <br />애플의 개발 언어인 스위프트를 활용해 만들어진 활동들은
            코딩하는 법, <br />프로토타입을 만드는 법등을 배우며, 세상을
            변화시킬 수 있는 방법을 생각하게 합니다. <br />Apple Swift 코딩클럽
            한국 호스트로서 귀하의 교육기관에 Coding 클럽을 운영 할 수도
            있습니다.
          </p>
          <b-button
            variant="link"
            href="https://www.apple.com/education/teaching-code/#coding-club"
            >더 알아보기</b-button
          >
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number
    }
  }
};
</script>

<style></style>
